<template>
  <GridsTwelveGrid>
    <h2 class="col-span-4 col-start-2 row-start-1 flex justify-center pb-8 laptop:block laptop:pb-[40px]">
      {{ $t("the-process") }}
    </h2>
    <div
      class="col-span-6 col-start-1 row-start-2 flex w-full flex-col items-center laptop:col-span-10 laptop:col-start-2 laptop:flex-row"
    >
      <slot />
    </div>
  </GridsTwelveGrid>
</template>
<script setup lang="ts">
const { t: $t } = useI18n();
</script>
<style lang="scss" scoped></style>
